export default __webpack_public_path__ + "static/media/game_logo.min.1b67dc42.png";